(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .directive('finalRatings', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                assessment: '=',
                risk: '=',
                onUpdate: '&',
                title: '@',
                readOnly: '=',
                layoutRatio: '=?'
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', 'commonRiskSelfAssessmentService', 'riskSelfAssessmentReviewService',
                function ($scope, commonRiskSelfAssessmentService, riskSelfAssessmentReviewService) {

                    $scope.getTemplateUrl = function () {
                        if ($scope.risk.RiskLevel.IsKeyRisk) return '/app/Main/riskSelfAssessment/review/finalRatings.Key.tpl.html';
                        if ($scope.risk.RiskLevel.IsTopRisk) return '/app/Main/riskSelfAssessment/review/finalRatings.Top.tpl.html';

                        return '';
                    }

                    // Set Probability Rating
                    $scope.setProbabilityRating = function (criteria) {
                        $scope.assessment.FinalProbabilityCode = criteria.Code;
                        $scope.assessment.FinalIsOverriden = false;

                        setOverallRatingRating();
                    };

                    // Set Severity Rating
                    $scope.setSeverityRating = function (criteria) {
                        $scope.assessment.FinalSeverityCode = criteria.Code;
                        $scope.assessment.FinalIsOverriden = false;

                        setOverallRatingRating();
                    };

                    // Set Mitigation Rating
                    $scope.setMitigationRating = function (criteria) {
                        $scope.assessment.FinalMitigationCode = criteria.Code;
                        $scope.assessment.FinalIsOverriden = false;

                        setOverallRatingRating();
                    };

                    // Set Overall Rating
                    $scope.setOverallRating = function (criteria) {
                        $scope.assessment.FinalOverallCode = criteria.Code;
                        $scope.assessment.FinalIsOverriden = true;

                        $scope.updateCriterias();
                    };

                    $scope.init = function () {

                        commonRiskSelfAssessmentService
                          .getAllCriteriasByTypeAndByCode()
                          .then(function (criterias) {
                              $scope.probabilityCriterias = criterias['Probability'];
                              $scope.mitigationCriterias = criterias['Mitigation'];
                              $scope.severityCriterias = criterias['Severity'];
                              $scope.overallCriterias = criterias['Overall'];
                              $scope.naCriteria = commonRiskSelfAssessmentService.getNACriteria();

                              $scope.updateCriterias();
                          });

                        // Layout Ratio
                        if (_.isUndefined($scope.layoutRatio)) $scope.layoutRatio = {};
                        $scope.layout = {};
                        $scope.layout.column = $scope.layoutRatio.column || 'col-sm-12';
                        $scope.layout.yearColumnSize = $scope.layoutRatio.yearColumnSize || '3';
                        $scope.layout.ratingColumnSize = $scope.layoutRatio.ratingColumnSize || '9';
                        $scope.layout.hideIcon = _.isBoolean($scope.layoutRatio.hideIcon) ? $scope.layoutRatio.hideIcon : false;
                        $scope.layout.hideLabels = _.isBoolean($scope.layoutRatio.hideLabels) ? $scope.layoutRatio.hideLabels : false;
                    };

                    $scope.updateCriterias = function () {
                        if (!$scope.probabilityCriterias) return;
                        if (!$scope.mitigationCriterias) return;
                        if (!$scope.severityCriterias) return;
                        if (!$scope.overallCriterias) return;

                        $scope.probabilityCriteria = $scope.probabilityCriterias[$scope.assessment.FinalProbabilityCode] || $scope.naCriteria;
                        $scope.mitigationCriteria = $scope.mitigationCriterias[$scope.assessment.FinalMitigationCode] || $scope.naCriteria;
                        $scope.severityCriteria = $scope.severityCriterias[$scope.assessment.FinalSeverityCode] || $scope.naCriteria;
                        $scope.overallCriteria = $scope.overallCriterias[$scope.assessment.FinalOverallCode] || $scope.naCriteria;

                        $scope.onUpdate();
                    };

                    function setOverallRatingRating() {
                        if (!$scope.assessment.FinalSeverityCode ||
                            !$scope.assessment.FinalProbabilityCode ||
                            !$scope.assessment.FinalMitigationCode) {

                            return;
                        }

                        commonRiskSelfAssessmentService
                                .computeOwnerOverallCriteria(
                                    $scope.assessment.FinalSeverityCode,
                                    $scope.assessment.FinalProbabilityCode,
                                    $scope.assessment.FinalMitigationCode
                                )
                                .then(function (computedOverallCriteria) {
                                    $scope.assessment.FinalComputedOverallCode = computedOverallCriteria.Code;
                                    $scope.assessment.FinalOverallCode = computedOverallCriteria.Code;

                                    $scope.updateCriterias();
                                });
                    }

                }],
            link: function (scope, elem, attrs) {

                scope.init();

                scope.$watch('assessment', function (newValue, oldValue) {
                    if (newValue) {
                        scope.updateCriterias();
                    }
                }, true);
            }
        }
    }
})();
